import {
    MantineProvider as MantineProviderBase,
    type MantineThemeOverride,
} from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { type FC } from 'react';
import { getMantine8ThemeOverride } from './mantineTheme';

type Props = {
    theme?: MantineThemeOverride;
    themeOverride?: MantineThemeOverride;
    notificationsLimit?: number;
};

const MantineProvider: FC<React.PropsWithChildren<Props>> = ({
    children,
    theme = getMantine8ThemeOverride(),
    themeOverride = {},
}) => {
    return (
        <MantineProviderBase theme={{ ...theme, ...themeOverride }}>
            <ModalsProvider>
                {children}
                <Notifications limit={5} position="bottom-right" />
            </ModalsProvider>
        </MantineProviderBase>
    );
};

export default MantineProvider;
